import {
  takeLatest, put, call, select,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import { AdsHandlerActionTypes } from './adsHandler.types';
import adsHandlerActions from './adsHandler.actions';

function* fetchAdsPages() {
  const { token } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: '/api/v1/ads/pages',
    headers: {
      'x-brand': brand,
      'x-token': token,
    },
  };

  try {
    const response = yield call(api.multiAgents.get, request);
    yield put(adsHandlerActions.pages.success(response.data));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas adsHandler - method fetchAdsPages', error);
    yield put(adsHandlerActions.pages.failure());
  }
}

function* unlinkAccount() {
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: '/api/v1/campaign/disconnect',
    headers: {
      'x-brand': brand,
      'x-token': token,
      'x-service-token': jwtToken,
    },
  };

  yield put(adsHandlerActions.unlinkAccount.unlinkAccountLoading(true));

  try {
    yield call(api.multiAgents.delete, request);
    yield put(adsHandlerActions.unlinkAccount.unlinkAccountSuccess());
    yield put(adsHandlerActions.unlinkAccount.unlinkAccountLoading(false));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas adsHandler - method unlinkAccount', error);
    yield put(adsHandlerActions.unlinkAccount.unlinkAccountFailure());
    yield put(adsHandlerActions.unlinkAccount.unlinkAccountLoading(false));
  }
}

function* fetchDrafts() {
  const { token } = yield select(state => state.auth);
  const { id: clientId } = yield select(state => state.summary);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: '/api/v1/campaign/retrieve/data',
    params: {
      clientId,
      brand,
    },
    headers: {
      'x-brand': brand,
      'x-token': token,
    },
  };

  try {
    const response = yield call(api.multiAgents.get, request);
    yield put(adsHandlerActions.drafts.success(response.data));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas adsHandler - method fetchDrafts', error);
    yield put(adsHandlerActions.drafts.failure());
  }
}

function* fetchInsights(action) {
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const { since, until, fields } = action.payload || {};

  const request = {
    url: '/api/v1/campaign/dashboard',
    params: {
      brand,
      ...(since && { since }),
      ...(until && { until }),
      ...(fields && { fields }),
    },
    headers: {
      'x-brand': brand,
      'x-token': token,
      'x-service-token': jwtToken,
    },
  };

  try {
    const response = yield call(api.multiAgents.get, request);
    yield put(adsHandlerActions.insights.success(response.data));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas adsHandler - method fetchInsights', error);
  }
}

function* sagas() {
  yield takeLatest(AdsHandlerActionTypes.ADS_HANDLER_PAGES_REQUEST, fetchAdsPages);
  yield takeLatest(AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_REQUEST, fetchDrafts);
  yield takeLatest(AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_REQUEST, unlinkAccount);
  yield takeLatest(AdsHandlerActionTypes.ADS_HANDLER_INSIGHTS_REQUEST, fetchInsights);
}

export default sagas;
